import EditOtherTaxes from './EditOtherTaxes';

export default EditOtherTaxes;
